import React from 'react';

/**
 * ChildProfile - Displays child's profile card with avatar, name and age
 */
export const ChildProfile = ({ child, t }) => {
  return (
    <div className="card border rounded-3 mb-4">
      <div className="card-body p-4">
        <div className="d-flex align-items-center">
          {/* Avatar - using zodiac sprite CSS classes */}
          <span
            className={`zodiac-icon zodiac-icon-${child.avatar} zodiac-icon-md zodiac-icon-circle me-3`}
            role="img"
            aria-label={child.zodiac_name || child.avatar}
          ></span>
          <div>
            <h3 className="h5 fw-bold mb-1">{child.username}</h3>
            <p className="text-muted mb-2">
              {t('curriculum.profile_card.age', { age: child.age })} &bull; {t('curriculum.profile_card.active_learner')}
            </p>
            <span className="badge bg-success bg-opacity-10 text-success">
              {t('curriculum.profile_card.activities_assigned', { count: child.activities_count })}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChildProfile;
